import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {Form, Typography} from 'antd'

import type {BankAccountCreateFormStaticFieldsProps} from './props'

export const StaticFields = observer((props: BankAccountCreateFormStaticFieldsProps) => {
    const {businessStructure, companyName} = props
    const { t } = useTranslation()
    
    return (
        <>
            <Form.Item label={t('BankAccountCreate.labels.entityType')} name='entityType'>
                <Typography.Text>{businessStructure}</Typography.Text>
            </Form.Item>
            <Form.Item label={t('BankAccountCreate.labels.legalName')} name='legalName'>
                <Typography.Text>{companyName}</Typography.Text>
            </Form.Item>
        </>
    )
})
